import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Estoy cansado todo el tiempo por la depresión?",
    answer:
      "La fatiga y el cansancio persistente pueden ser síntomas de la depresión. Si los síntomas no mejoran con el tratamiento actual, una consulta con el equipo clínico puede ayudar a evaluar opciones.",
  },
];

export const esAlwaysTiredFatigue = makeEsArticle({
  slug: "always-tired-depression-fatigue",
  title: "¿Cansado todo el tiempo? Fatiga y depresión",
  description:
    "La fatiga persistente puede ser un síntoma de la depresión. Si los síntomas no mejoran con el tratamiento actual, una consulta puede ayudar a evaluar opciones.",
  h1: "¿Cansado todo el tiempo? Fatiga y depresión",
  breadcrumbLabel: "Fatiga y depresión",
  shortAnswer:
    "La fatiga y el cansancio persistente pueden ser síntomas de la depresión. Cuando estos síntomas no mejoran lo suficiente con el tratamiento actual, una consulta con el equipo clínico puede ayudar a evaluar si existen otras opciones, incluida SAINT® para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos. No hay garantías de resultados; los resultados individuales pueden variar.",
  keyTakeaways: [
    "La fatiga persistente puede ser un síntoma de la depresión.",
    "Si los síntomas no mejoran, una consulta puede ayudar.",
    "SAINT® es una opción para adultos con trastorno depresivo mayor.",
    "SAINT® está indicada cuando los antidepresivos no han mejorado lo suficiente.",
    "No hay garantías; los resultados pueden variar.",
  ],
  sections: [
    {
      heading: "Fatiga y depresión",
      paragraphs: [
        "La fatiga, la falta de energía y el cansancio persistente pueden formar parte de los síntomas de la depresión. Si estos síntomas persisten a pesar del tratamiento, conviene revisar el plan con un profesional.",
      ],
    },
    {
      heading: "Opciones si el tratamiento no basta",
      paragraphs: [
        "Si los antidepresivos no han producido una mejoría suficiente, SAINT® es una opción autorizada por la FDA para el trastorno depresivo mayor en adultos. La elegibilidad se confirma mediante una evaluación psiquiátrica. No está indicada para ansiedad, trastorno bipolar, TEPT u otras condiciones.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
